module.exports = __webpack_public_path__ + "img/icon_highlights.b4d3314e.png";